<div *ngIf="showControls" class="paper fax-pdf-viewer-controls">
  <div *ngFor="let controlGroup of controlGroups" class="fax-pdf-viewer-controls__group">
    <button
      *ngFor="let controlButton of controlGroup"
      class="icon-btn icon-btn_md"
      (click)="controlButton.onClick()"
    >
      <img [src]="controlButton.imgSrc" [alt]="controlButton.imgAlt" />
    </button>
  </div>
</div>

<div *ngIf="showControls" class="fax-pdf-viewer-controls__select-group">
  <app-select
    [items]="folderSelectOptions"
    [activeItem]="selectedFolderName"
    placeholder="Select folder"
    customClass="select_l"
    (selectChange)="selectFolderName($event)"
  ></app-select>

  <button class="icon-btn icon-btn_md" [disabled]="!selectedFolderName" (click)="saveToFolder()">
    <img src="assets/icons/save.svg" alt="Save document to folder" />
  </button>

  <button *ngIf="showResendButton" class="btn_primary btn_lg" (click)="resendClick.emit()">Resend</button>
</div>

<div class="fax-pdf-viewer" [class.fax-pdf-viewer_horizontal]="isHorizontalViewer()">
  <pdf-viewer
    [src]="faxFileSrc"
    [page]="faxFilePage"
    [rotation]="pdfRotationDeg"
    [show-all]="false"
    [original-size]="false"
    [autoresize]="true"
    [render-text]="true"
    class="previews-pages__page"
    (page-rendered)="setViewerScaleToPageHeight()"
  ></pdf-viewer>
</div>
